import MessageBanner from 'LuxKit/Banners/MessageBanner'
import { urlHashDatePicker } from 'constants/url'
import { EmptyObject } from 'lib/object/objectUtils'
import offerPageURL from 'lib/offer/offerPageURL'
import { buildSearchParamsFromFilters } from 'lib/search/searchUtils'
import React, { useMemo } from 'react'
import { OfferUnavailableReason } from 'lib/search/constants'

interface Props {
  offer: App.BedbankOffer | App.BedbankOfferSummary
  unavailableReason: string | undefined
  filters?: App.OfferListFilters
}

function BedbankSearchTileUnavailabilityBanner({
  offer,
  unavailableReason,
  filters = EmptyObject,
}: Props) {
  const offerUrl = useMemo(() => {
    const searchParams = buildSearchParamsFromFilters({
      ...filters,
      checkIn: undefined,
      checkOut: undefined,
    })

    if (unavailableReason === OfferUnavailableReason.CAPACITY_EXCEEDED || unavailableReason === OfferUnavailableReason.UNAVAILABLE_FOR_FILTERS_SELECTED) {
      return offerPageURL(offer, searchParams)
    }

    return offerPageURL(offer, searchParams) + urlHashDatePicker
  }, [filters, offer, unavailableReason])

  const bannerMessage = useMemo(() => {
    if (unavailableReason === OfferUnavailableReason.CAPACITY_EXCEEDED) {
      return 'Unavailable for the number of guests selected'
    }
    if (unavailableReason === OfferUnavailableReason.UNAVAILABLE_FOR_FILTERS_SELECTED) {
      return 'Unavailable for your filters'
    }
    return 'Unavailable for your dates'
  }, [unavailableReason])

  const actionButtonText = useMemo(() => {
    if (unavailableReason === OfferUnavailableReason.CAPACITY_EXCEEDED || unavailableReason === OfferUnavailableReason.UNAVAILABLE_FOR_FILTERS_SELECTED) {
      return 'View offer'
    }
    return 'View available dates'
  }, [unavailableReason])

  const primaryActionButtonProps = useMemo(() => ({
    children: actionButtonText,
    to: offerUrl,
    target: '_blank',
  }), [actionButtonText, offerUrl])

  return <MessageBanner
    kind="informational-primary"
    primaryActionButtonProps={primaryActionButtonProps}
    data-testid="bedbank-search-tile-unavailability-banner"
  >
    <b>{bannerMessage}</b>
  </MessageBanner>
}

export default BedbankSearchTileUnavailabilityBanner
